@if (loading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ "GENERAL.loading" | translate }}...
    </mat-label>
  </div>
}
<div class="as-create-list-container">
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  @if (data === null) {
    <p
      class="as-font-black-gray as-roboto-slab as-font-24 as-font-bold title"
      >
      {{ "LISTS.create" | translate }}
    </p>
  }
  @if (data !== null) {
    <p
      class="as-font-black-gray as-roboto-slab as-font-24 as-font-bold title"
      >
      {{ "LISTS.edit" | translate }}
    </p>
  }
  <form autocomplete="off" [formGroup]="nameList">
    <div class="cont">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ "LISTS.listName" | translate }}</mat-label>
        <input maxlength="25" type="text" formControlName="name" matInput required />
        @if (nameList.get('name')?.errors) {
          <mat-error>
            @if (nameList.get('name')?.errors?.required) {
              <span>{{
                "LISTS.required" | translate
              }}</span>
            }
          </mat-error>
        }
        @if (nameList.get('name')?.hasError('wrong')) {
          <mat-error>
            {{ "LISTS.wrong" | translate }}
          </mat-error>
        }
      </mat-form-field>

      <p class="as-font as-font-14 as-font-blackish mb-10 mb-title-choice">
        {{ "LISTS.choiceImage" | translate }}
      </p>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ "LISTS.categories" | translate }}</mat-label>
        <mat-select type="text" formControlName="topic" required>
          @for (item of topicsArr; track item) {
            <mat-option [value]="item.topic">
              {{ item.topic }}
            </mat-option>
          }
        </mat-select>
        @if (nameList.get('topic')?.errors) {
          <mat-error>
            @if (nameList.get('topic')?.errors?.required) {
              <span>{{
                "LISTS.required" | translate
              }}</span>
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </form>

  @if (imageSelected !== undefined) {
    <div class="carousel-container">
      <div class="img-cont">
        <img #img class="as-pointer" [src]="imageSelected" alt="" (error)="img.src = urlTemporal"/>
      </div>
    </div>
  }

  <div class="btn-container">
    <button mat-dialog-close mat-stroked-button color="accent">
      {{ "LISTS.cancel" | translate }}
    </button>
    @if (data === null) {
      <button
        [disabled]="nameList.invalid"
        (click)="createList()"
        mat-flat-button
        color="accent"
        >
        {{ "LISTS.add" | translate }}
      </button>
    }
    @if (data !== null) {
      <button
        [disabled]="nameList.invalid"
        (click)="editList()"
        mat-flat-button
        color="accent"
        >
        {{ "LISTS.saveList" | translate }}
      </button>
    }
  </div>
</div>
